// 创建一个唯一的reducer
import {controls} from './control'
import {user} from "@/store/reducer/user";
import {combineReducers} from 'redux'

export default combineReducers({
    controls,
    user
})
